export { Tabs, TabList, Tab, TabPanel } from './Tabs';

export type { TabsProps } from '@mui/joy/Tabs';
export type { TabListProps } from '@mui/joy/TabList';
export type { TabProps } from '@mui/joy/Tab';
export type { TabPanelProps } from '@mui/joy/TabPanel';

export { tabClasses } from '@mui/joy/Tab';
